import React, { Component } from 'react';
import { Table, TableHeader, TableHeaderCell, TableBody, TableRow, TableCell, Flex, IconButton, Button, Label, Tooltip, Modal, ModalContent, ModalFooterButtons, MenuButton, Menu, MenuItem, Checkbox, Search, TextField, Icon } from 'monday-ui-react-core';
import { Heading } from "monday-ui-react-core/next";
import { Erase, DropdownChevronDown, Duplicate, Filter, Board, BoardPrivate } from "monday-ui-react-core/icons";
import classes from "./backups-table.module.scss";
import BackupEditor from '../backup-editor/backup-editor';
import { showNotice, openLink } from '../../services/error-handling';
import { createNewBackup, deleteBackup, fetchAllBackups, restoreBackup } from '../../services/backend-service';
import { valueCreated } from '../../services/hooks';
import mondaySdk from "monday-sdk-js";

class BackupsTable extends Component {  
  constructor(props) {
    super(props);
    this.state = {
      workspaceId: props.workspaceId,
      userId: props.userId,
      isAdmin: false,
      tableData: props.selectedWorkspaceData || [],
      restoreBackupModal: false,
      restoreBackupModalIndex: -1,
      restoreBackupStrategy: null,
      showRestoreBackupModal: false,
      deleteBackupModal: false,
      deleteBackupModalIndex: -1,
      createBackupScreen: false,
      typeFilterBoardsChecked: true,
      typeFilterBoardGroupsChecked: true,
      typeFilterDocsChecked: true,
      typeFilterItemsChecked: true,
      searchString: null,
      filtersLoading: false,
      showFilters: false,
      currentPage: 1,
      limit: 20,
      totalPages: null,
      isErasing: false
    };
  }

  componentDidMount() {
    const monday = mondaySdk();

    monday.listen("context", (res) => {
      this.setState({
        isAdmin: res.data.user.isAdmin,
        isGuest: res.data.user.isGuest,
        isViewOnly: res.data.user.isViewOnly,
        userId: res.data.user.id,
        workspaceId: res.data.workspaceId,
        timeZoneOffset: res.data.user.timeZoneOffset
      });

      this.reloadBackups(this.state.currentPage, res.data.workspaceId);
    });
  }

  async createBackup(requestData) {
    let backup = {
      workspaceId: requestData.workspaceId,
      boardId: requestData.boardId,
      backupName: requestData.backupName,
      boardName: requestData.itemName,
      ownerId: requestData.userId,
      backupType: requestData.backupType,
      backupVisibility: requestData.backupVisibility,
      metadata: requestData.metadata,
    }

    try {
      await createNewBackup(requestData.workspaceId, backup);
      await this.reloadBackups(this.state.currentPage);

      showNotice("success", "Snapshot created successfully");
      valueCreated();
      this.clickNewBackupScreen(false);
    } catch(error) {
      console.log(error);
      showNotice("error", "An error has occured while creating snapshot. Please try again.");
    }
  }

  clickNewBackupScreen(showScreen) {
    this.setState({
      createBackupScreen: showScreen
    });
  }

  async restore(index, restoreBackupStrategy) {
    try {
      this.setState({
        filtersLoading: true
      });

      this.closeRestoreBackupModal();
      showNotice("info", "Restoring snapshot...");

      let restoredBoard = null;
      if(restoreBackupStrategy === "copy") {
        const backup = this.state.tableData[index];
        restoredBoard = await restoreBackup(backup.workspaceId, backup.id);
        showNotice("success", "Snapshot restored successfully");
        valueCreated();
        openLink(restoredBoard.restoredBoardUrl);
      }
    } catch(error) {
      console.log(error);
      this.closeRestoreBackupModal();
      showNotice("error", "An error has occured while restoring snapshot. Please try again.");
    } finally {
      this.setState({
        filtersLoading: false
      });
    }
  }

  async erase(index) {
    if (this.state.isErasing) return;

    this.setState({ isErasing: true });
    
    try {
      const backup = this.state.tableData[index];
      await deleteBackup(backup.workspaceId, backup.id);
      if((this.state.tableData.length === 1) && (this.state.currentPage > 1)) {
        await this.reloadBackups(this.state.currentPage - 1);
      } else {
        await this.reloadBackups(this.state.currentPage);
      }
      

      this.closeDeleteBackupModal();
      showNotice("success", "Snapshot deleted successfully");
    } catch(error) {
      console.log(error);
      this.closeDeleteBackupModal();
      showNotice("error", "An error has occured while deleting snapshot. Please try again.");
    } finally {
      this.setState({ isErasing: false });
    }
  }

  closeRestoreBackupModal() {
    this.setState({ 
      restoreBackupModalIndex: -1,
      restoreBackupModal: false,
      restoreBackupStrategy: null
    });
  }

  closeDeleteBackupModal() {
    this.setState({ 
      deleteBackupModalIndex: -1,
      deleteBackupModal: false
    });
  }

  async reloadBackups(page, workspaceId) {
    this.setState({
      filtersLoading: true
    });

    let typeFilters = [];
    if(this.state.typeFilterBoardsChecked) typeFilters.push("board");
    if(this.state.typeFilterBoardGroupsChecked) typeFilters.push("group");
    if(this.state.typeFilterDocsChecked) typeFilters.push("doc");
    if(this.state.typeFilterItemsChecked) typeFilters.push("items");

    try {
      let data = await fetchAllBackups(workspaceId ? workspaceId : this.state.workspaceId, this.state.searchString, ((typeFilters.length > 0) ? typeFilters : null), page, this.state.limit);

      this.setState({
        tableData: data.backups,
        currentPage: data.page,
        limit: data.limit,
        totalPages: data.totalPages,
        filtersLoading: false
      });
    } catch(e) {
      console.log(e);

      this.setState({
        filtersLoading: false
      });
    }
  }

  render() {

    return (
      <Flex align={Flex.align.START} gap={Flex.gaps.MEDIUM} direction={Flex.directions.ROW} className={classes.fullWidth}>
        {(!this.state.createBackupScreen) 
        ? <Flex align={Flex.align.START} gap={Flex.gaps.SMALL} direction={Flex.directions.COLUMN} className={classes.fullWidth}>
          <Flex align={Flex.align.START} gap={Flex.gaps.SMALL} direction={Flex.directions.ROW}>
            <Heading type={Heading.types.H2}>Snapshots in this workspace</Heading>
          </Flex>
          <Flex align={Flex.align.CENTER} gap={Flex.gaps.MEDIUM} direction={Flex.directions.ROW}>
            <Button 
              size={Button.sizes.SMALL} 
              kind={Button.kinds.PRIMARY}
              onClick={() => {
                this.clickNewBackupScreen(true)
              }}
            >
              New snapshot
            </Button>
            {(!this.state.showFilters) 
            ? <Button 
              size={Button.sizes.SMALL} 
              kind={Button.kinds.TERTIARY}
              onClick={() => {
                this.setState({
                  showFilters: true
                });
              }}
              leftIcon={Filter}
            >
              Filter results
            </Button>
            : <div></div>}
            {(this.state.showFilters) 
            ? <Flex align={Flex.align.CENTER} gap={Flex.gaps.MEDIUM} direction={Flex.directions.ROW}>
              <TextField
                size={Search.sizes.SMALL} 
                placeholder="Search..."
                wrapperClassName="monday-storybook-text-field_size"
                value={this.state.searchString}
                onChange={async (str) => {
                  this.setState({
                    searchString: str
                  });
                }}
              />
              <Checkbox
                defaultChecked={this.state.typeFilterBoardsChecked}
                label="Boards"
                onChange={async () => { 
                  this.setState({
                    typeFilterBoardsChecked: !this.state.typeFilterBoardsChecked
                  }) 
                }}
              />
              <Checkbox
                defaultChecked={this.state.typeFilterBoardGroupsChecked}
                label="Board Groups"
                onChange={async () => { 
                  this.setState({
                    typeFilterBoardGroupsChecked: !this.state.typeFilterBoardGroupsChecked
                  }) 
                }}
              />
              <Checkbox
                defaultChecked={this.state.typeFilterDocsChecked}
                label="Docs"
                onChange={async () => { 
                  this.setState({
                    typeFilterDocsChecked: !this.state.typeFilterDocsChecked
                  }) 
                }}
              />
              <Checkbox
                defaultChecked={this.state.typeFilterItemsChecked}
                label="Items"
                onChange={async () => { 
                  this.setState({
                    typeFilterItemsChecked: !this.state.typeFilterItemsChecked
                  }) 
                }}
              />
              <Button 
                size={Button.sizes.SMALL} 
                kind={Button.kinds.TERTIARY}
                loading={this.state.filtersLoading}
                disabled={this.state.filtersLoading}
                onClick={() => {
                  this.reloadBackups(this.state.currentPage);
                }}
                leftIcon={Filter}
              >
                Apply filters
              </Button>
            </Flex>
            : <div></div>}
            <Modal 
              alertDialog 
              title="Are you sure?" 
              show={this.state.restoreBackupModal} 
              width={Modal.width.DEFAULT}
              onClose={() => {
                this.closeRestoreBackupModal();
              }}  
              contentSpacing
            >
              <ModalContent>Are you sure you want to restore this snapshot?</ModalContent>
              <ModalFooterButtons 
                primaryButtonText="Confirm" 
                secondaryButtonText="Cancel" 
                onPrimaryButtonClick={() => {
                  this.restore(this.state.restoreBackupModalIndex, this.state.restoreBackupStrategy);
                }} 
                onSecondaryButtonClick={() => {
                  this.closeRestoreBackupModal();
                }}
              />
            </Modal>
            <Modal 
              alertDialog 
              title="Are you sure?" 
              show={this.state.deleteBackupModal} 
              width={Modal.width.DEFAULT}
              onClose={() => {
                this.closeDeleteBackupModal();
              }}  
              contentSpacing
            >
              <ModalContent>Are you sure you want to delete this snapshot?</ModalContent>
              <ModalFooterButtons 
                primaryButtonText="Confirm" 
                secondaryButtonText="Cancel" 
                onPrimaryButtonClick={() => {
                  this.erase(this.state.deleteBackupModalIndex);
                }} 
                onSecondaryButtonClick={() => {
                  this.closeDeleteBackupModal();
                }}
              />
            </Modal>
          </Flex>
          <div class={classes.tableDiv}>
            {(this.state.tableData.length > 0) 
              ? <Flex align={Flex.align.START} gap={Flex.gaps.SMALL} direction={Flex.directions.COLUMN} className={classes.fullWidth}>
                <Table 
                  className={classes.backupTable}
                  size={Table.sizes.MEDIUM}
                  columns={[
                      {
                          id: 'name',
                          loadingStateType: 'medium-text',
                          title: 'Snapshot Name'
                      },
                      {
                        id: 'description',
                        loadingStateType: 'long-text',
                        title: 'Description'
                      },
                      {
                        id: 'visibility',
                        loadingStateType: 'long-text',
                        title: 'Visibility'
                      },
                      {
                        id: 'type',
                        loadingStateType: 'medium-text',
                        title: 'Item'
                      },
                      {
                        id: 'type',
                        loadingStateType: 'medium-text',
                        title: 'Item Type'
                      },
                      {
                        id: 'createdOn',
                        loadingStateType: 'medium-text',
                        title: 'Created On'
                      },
                      {
                          id: 'actions',
                          loadingStateType: 'medium-text',
                          title: '',
                          width: 200
                      }
                  ]}
                >
                  <TableHeader className={classes.backupTableHeader}>
                      <TableHeaderCell title="Snapshot Name" infoContent="Name of snapshot assigned at creation" />
                      <TableHeaderCell title="Description" infoContent="Description of the snapshot" />
                      <TableHeaderCell title="Visibility" infoContent="Who can see and manage this snapshot" />
                      <TableHeaderCell title="Item" infoContent="Name of the item that is backed up" />
                      <TableHeaderCell title="Item Type" infoContent="Type of the item"/>
                      <TableHeaderCell title="Created On" infoContent="When was the snapshot created"  />
                      <TableHeaderCell title="" />
                  </TableHeader>
                  <TableBody>
                    {this.state.tableData.map((row, index) => (
                      <TableRow 
                        key={index}
                      >
                        <TableCell>
                            {row.backupName}
                        </TableCell>
                        <TableCell>
                          {row.metadata.description}
                        </TableCell>
                        <TableCell className={classes.normalFont}><Icon icon={(row.backupVisibility === "private") ? BoardPrivate : Board} /> {(row.backupVisibility === "private") ? " Private" : " Public"}</TableCell>
                        <TableCell>{row.boardName}</TableCell>
                        <TableCell>
                          {(row.backupType === "doc")
                          ? <Label color={Label.colors.DARK} kind={Label.kinds.FILL} text="Doc" isAnimationDisabled />
                          : (row.backupType === "group") 
                            ? <Label color={Label.colors.POSITIVE} kind={Label.kinds.FILL} text="Board Group" isAnimationDisabled />
                            : (row.backupType === "board") 
                              ? <Label color={Label.colors.PRIMARY} kind={Label.kinds.FILL} text="Board" isAnimationDisabled />
                              : (row.backupType === "items") 
                                ? <Label color={Label.colors.NEGATIVE} kind={Label.kinds.FILL} text="Item(s)" isAnimationDisabled />
                                : <div></div>}
                        </TableCell>
                        <TableCell>{row.lastUpdated ? new Date(row.lastUpdated).toString() : "Just now"}</TableCell>
                        <TableCell>
                          <Flex align={Flex.align.CENTER} gap={Flex.gaps.SMALL} direction={Flex.directions.ROW}>
                            <MenuButton
                              className={classes.normalFont}
                              text="Restore"
                              component={DropdownChevronDown}
                              disabled={this.state.filtersLoading}
                              size={MenuButton.sizes.SMALL}
                              componentPosition={MenuButton.componentPositions.END}
                            >
                              <Menu size={Menu.sizes.SMALL}>
                                <MenuItem 
                                  icon={Duplicate} 
                                  onClick={() => {
                                    this.setState({ 
                                      restoreBackupModal: true,
                                      restoreBackupModalIndex: index,
                                      restoreBackupStrategy: "copy"
                                    });
                                  }} 
                                  iconType="svg" 
                                  title={(row.backupType === "doc") ? "Restore as new doc" : "Restore as new board" } />
                              </Menu>
                            </MenuButton>
                            <Tooltip content={(!this.state.isAdmin && ((this.state.userId + "") !== ("" + row.ownerId))) ? "Only the owner or an admin may delete this snapshot" : "Delete"} position={Tooltip.positions.BOTTOM} animationType={Tooltip.animationTypes.EXPAND} maxWidth>
                              <IconButton
                                color={IconButton.colors.NEGATIVE}
                                icon={Erase}
                                kind="tertiary"
                                size={IconButton.sizes.SMALL}
                                disabled={this.state.filtersLoading || (!this.state.isAdmin && ((this.state.userId + "") !== ("" + row.ownerId)))}
                                onClick={() => {
                                  this.setState({ 
                                    deleteBackupModal: true,
                                    deleteBackupModalIndex: index
                                  });
                                }}
                              />
                            </Tooltip>
                          </Flex>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                <Flex align={Flex.align.CENTER} justify={Flex.justify.CENTER} gap={Flex.gaps.MEDIUM} direction={Flex.directions.ROW} className={classes.fullWidth}>
                  <Button
                    size={Button.sizes.SMALL}
                    disabled={(this.state.currentPage === 1) || this.state.filtersLoading}
                    kind={Button.kinds.TERTIARY}
                    onClick={() => {
                      this.reloadBackups(this.state.currentPage - 1);
                    }}
                  >
                    &lt;
                  </Button>
                  <div className={classes.subtitle}>Page {this.state.currentPage} of {this.state.totalPages}</div>
                  <Button
                    size={Button.sizes.SMALL}
                    disabled={(this.state.currentPage >= this.state.totalPages) || this.state.filtersLoading}
                    kind={Button.kinds.TERTIARY}
                    onClick={() => {
                      this.reloadBackups(this.state.currentPage + 1);
                    }}
                  >
                    &gt;
                  </Button>
                </Flex>
              </Flex>
            : <Flex align={Flex.align.CENTER} gap={Flex.gaps.SMALL} direction={Flex.directions.COLUMN}>
              <div className={classes.emptyStateComponent}>
                <div className={classes.emptyStateContainer}>
                  <img className={classes.emptySetImg} alt="No backups found" src="/monday/bb/v1/config/images/empty-set.png" />
                </div>
                <div className={classes.ctaContainer}>
                  <div className={classes.ctaContainerTitle}>No snapshots were found for this workspace</div>
                  <div className={classes.ctaContainerSubtitle}>Please create a new snapshot and it will be displayed here</div>
                </div>
              </div>
            </Flex>
            }
          </div>
        </Flex>
        : <div></div>
        }
        {(this.state.createBackupScreen) 
          ? <BackupEditor 
            onCloseClick={() => this.clickNewBackupScreen(false)} 
            onCreateBackupClick={(request) => this.createBackup(request) }
            workspaceId={this.state.workspaceId}
          />
          : <div></div>
        }
      </Flex>
    );
  }
}

export default BackupsTable;
